import wsCookies from 'common/tools/ws-cookies';
import { useGeo } from 'data/useGeo';
import { useZipCodeObjectData } from 'data2/useZipCodeObjectData';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';

interface ZipBase {
  zipCode: string;
}

export const useSearchDistance = <T extends ZipBase>(schema: any) => {
  const dispatch = useDispatch();
  const zipCodeObj = useSelector((state: RootState) => searchParamSelectors.zipCodeObj(state));
  const { findOne: findZCO } = useZipCodeObjectData();
  const { getGeoZip } = useGeo();

  const zipCodeObjMemo = React.useMemo(() => zipCodeObj, [zipCodeObj]);
  const searchDistanceInit = async () => {
    const distance = wsCookies.get('distance');
    if (distance) {
      dispatch(searchParamActions.distance(distance));
    }

    let zipCode = wsCookies.get('zipCode');
    if (!zipCode) zipCode = await getGeoZip();
    if (zipCode) {
      const zo = await findZCO(zipCode);
      if (zo) dispatch(searchParamActions.zipCodeObj(zo));
      else zipCode = undefined;
    }
    return { zipCode, distance };
  };

  const searchZipCodeValidate = async (values: T) => {
    const errors: any = {};

    if (schema.fields.zipCode.isValidSync(values.zipCode)) {
      if (zipCodeObjMemo?.code !== values.zipCode) {
        const zo = await findZCO(values.zipCode);
        if (zo) {
          dispatch(searchParamActions.zipCodeObj(zo));
          wsCookies.set('zipCode', values.zipCode);
        } else {
          dispatch(searchParamActions.zipCodeObj());
          errors.zipCode = 'Not found';
        }
      }
    } else {
      if (zipCodeObjMemo) dispatch(searchParamActions.zipCodeObj());
    }
    return errors;
  };

  return { searchDistanceInit, searchZipCodeValidate };
};
